import { ProductConnectivityState, ProductPeripheralsState, Workspace } from 'zens-store'
import { Color } from 'zens-storybook'

export function colorForWorkspaceStatus(workspace: Workspace) {
  const { connectivityState, peripheralsState } = workspace

  switch (peripheralsState) {
    case ProductPeripheralsState.SensorDisconnected:
    case ProductPeripheralsState.LedDisconnected:
    case ProductPeripheralsState.SensorAndLedDisconnected:
      return Color.red
  }

  switch (connectivityState) {
    case ProductConnectivityState.ConnectivityLost:
      return Color.collCopper
    case ProductConnectivityState.Disconnected:
      return Color.red
  }

  return connectivityState === ProductConnectivityState.Connected &&
    peripheralsState === ProductPeripheralsState.Connected
    ? Color.green
    : Color.calmGrey
}
